<template>
    <v-container>
        <form ref="form">
            <input name="id" v-model="item.id" />
            <v-row>
                <v-col cols="12" md="6">
                    <v-autocomplete
                        label="Tipo"
                        :items="tipos"
                        v-model="item.id_tipo"
                        name="id_tipo"
                        item-text="nombre"
                        item-value="id"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                    <v-text-field
                        label="Importe"
                        name="importe"
                        v-model="item.importe"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <v-file-input
                        accept="image/*"
                        label="Archivo"
                        name="archivo"
                        v-model="item.imagen"
                    ></v-file-input>
                </v-col>
            </v-row>
        </form>
        <v-row>
            <v-col cols="12">
                <v-btn
                    color="primary"
                    class="white--text"
                    @click="SaveConsumoOrden"
                    >Guardar</v-btn
                >
                <v-btn color="red" class="white--text" @click="SaveConsumoOrden"
                    >Limpiar</v-btn
                >
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table :items="items" :headers="headers">
                    <template v-slot:item.nombre_archivo="{ item }">
                        <a target="_blank" :href="item.url">
                            <img :src="item.url" width="auto" height="60px" />
                        </a>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-icon
                            @click="setItem(item)"
                            small
                            class="mr-2"
                            color="#1d2735"
                            style="font-size: 25px"
                            title="EDITAR"
                            >mdi-pencil-outline</v-icon
                        >

                        <v-icon
                            @click="openDeleteDialog(item)"
                            small
                            class="mr-2"
                            color="red"
                            style="font-size: 25px"
                            title="BORRAR"
                            >mdi-trash-can</v-icon
                        >
                    </template></v-data-table
                >
            </v-col>
        </v-row>
        <v-dialog v-model="delete_dialog" max-width="360px">
            <v-card>
                <div
                    class="tittlecard"
                    style="
                        background-color: #1d2735 !important;
                        font-family: monospace !important;
                    "
                >
                    <v-custom-title
                        text="Eliminar Usuario"
                        class="white--text mx-4"
                        style="font-size: 30px; font-weight: bold !important"
                        >Eliminar consumo</v-custom-title
                    >
                </div>
                <v-card-title>
                    ¿Está seguro que desea eliminar este consumo?
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red"
                        class="white--text"
                        rounded
                        @click="deleteConsumos()"
                    >
                        Sí, eliminar
                    </v-btn>
                    <v-btn
                        color="green"
                        class="white--text"
                        rounded
                        @click="
                            delete_dialog = false;
                            id_to_delete = null;
                        "
                    >
                        No, cancelar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
export default {
    props: ["value"],
    data() {
        return {
            delete_dialog: false,
            item: {},
            tipos: [],
            archivos: [],
            items: [],
            id_to_delete: {},
            headers: [
                { text: "Empleado", value: "empleado.name", sortable: false },

                { text: "Tipo", value: "tipo.nombre", sortable: false },

                { text: "Importe", value: "importe", sortable: false },
                { text: "Imagen", value: "nombre_archivo", sortable: false },

                { text: "Acciones", value: "action", sortable: false },
            ],
        };
    },
    created() {
        this.getTipos();
    },
    mounted() {
        this.getConsumos();
    },
    watch: {
        value(val) {
            this.item = {};
            this.getConsumos();
        },
    },
    methods: {
        setItem(item) {
            this.item = item;
        },
        openDeleteDialog(item) {
            this.delete_dialog = true;
            this.id_to_delete = item.id;
        },
        SaveConsumoOrden() {
            const formData = new FormData(this.$refs.form);
            formData.append("id_orden", this.value.id);
            axios.post(`api/save-consumos-orden`, formData).then((res) => {
                //this.items = res.data;
                this.item = {};
                this.getConsumos();
            });
        },
        deleteConsumos() {
            axios
                .get(`api/delete-consumos-orden/${this.id_to_delete}`)
                .then((res) => {
                    this.getConsumos();
                    this.delete_dialog = false;
                    this.id_to_delete = null;
                });
        },
        getTipos() {
            axios.get(`api/get-tipos-gastos`).then(
                (res) => {
                    this.tipos = res.data;
                    this.tipos.shift();
                    this.tipos.shift();
                },
                (err) => {
                    this.$custom_error("Error consultando los tipos de gasto");
                }
            );
        },
        getConsumos() {
            if (this.value == null) return;
            axios.get(`api/get-consumos-orden/${this.value.id}`).then((res) => {
                this.items = res.data;
            });
        },
    },
};
</script>
